document.addEventListener('DOMContentLoaded', function () {
    var mobileMediaQuery = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('a.o-btn-lvl1.category-menu-item').forEach(function (link) {
        link.addEventListener('click', function (e) {
            if (mobileMediaQuery.matches) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.parentElement.classList.toggle('clicked');
            }
        });
    });
});
